<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">
    <div class="w-full p-2 flex-1">

      <div class="text-sm text-gray-800 font-semibold flex flex-col gap-4 mb-6">
        <button (click)="onCancel()" class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">
          Annuler
        </button>

        <button (click)="onSelect('stripe')"
          class="w-full font-bold text-lg py-4 shadow-md rounded-full bg-[#4d47dc] text-white">
          Carte bancaire (Stripe)
        </button>

        <button [disabled]="true" class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">
          PayPal (à venir)
        </button>

        <button [disabled]="true" class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">
          Google Pay (à venir)
        </button>
      </div>
    </div>
</app-dialog-wrapper>